export const donationInputs = {
    name: {
        label:"Name",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Enter your name please"
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && this.value.length >=3 && this.value.length <=30){
                valid = true;
            }
            return valid
        },
        isValid: true, 
        errorMessage: "Name must be up to 3 letters",
        touched: false,
        iconName:"person"
    },
    email: {
        label:"Email",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Email", 
        },
        value:"",
        validation: function(){
            let valid = false;
            const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
            if(emailRegex.test(this.value)){
                valid = true
            }
            return valid
        },
        isValid: false,
        errorMessage: "Please input a valid email address",
        touched: false,
    },
    message: {
        label:"Message",
        elemType: "textarea",
        config: {
            placeholder: "Enter your message",
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && this.value.length >=10){
                valid = true;
            }
            return valid
        },
        isValid: true,
        errorMessage: "Please drop a nice message",
        touched: false,
    }, 
    amount: {
        label:"Amount (#)",
        elemType: "input",
        config: {
            type: 'text', 
            placeholder: "Enter the amount you wish to provide please"
        },
        value:"",
        validation: function(){
            let valid = false;
            if(this.value.trim() !== '' && !isNaN(this.value)){
                valid = true;
            }
            return valid
        },
        isValid: false,
        errorMessage: "Please add the donation amount",
        touched: false,
    }
}